import { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePlatformContext } from '../Platform/PlatformContext';
import { getPlatformTypeFromParams } from '../Platform/utils';
import { extractPlatformParams } from '../Platform/utils';
import ConfirmModal from '../../Cafe24Auth/ConfirmModal';
import ErrorModal from '../../Cafe24Auth/ErrorModal';

const PlatformAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setPlatformInfo, platformInfo } = usePlatformContext();
  const [isCafe24AuthConfirmModalOpen, setIsCafe24AuthConfirmModalOpen] = useState(false);
  const [isCafe24AuthErrorModalOpen, setIsCafe24AuthErrorModalOpen] = useState(false);

  const cafe24AuthWindowRef = useRef<Window | null>(null);

  const openCenteredWindow = (url: string, target: string, width: number, height: number) => {
    // 화면의 중앙 위치 계산
    const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const innerWidth = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
    const innerHeight = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

    const left = (innerWidth - width) / 2 + screenLeft;
    const top = (innerHeight - height) / 2 + screenTop;

    // 새 창 열기
    cafe24AuthWindowRef.current = window.open(url, target, `width=${width},height=${height},top=${top},left=${left}`);
  };

  useEffect(() => {
    const detectedPlatformType = getPlatformTypeFromParams(searchParams);

    if (detectedPlatformType) {
      const params = extractPlatformParams(searchParams, detectedPlatformType);
      if (params) {
        setPlatformInfo(detectedPlatformType, params);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    // 페이지 언마운트 시 cafe24 인증창이 열려 있으면 닫기
    return () => {
      if (cafe24AuthWindowRef.current && !cafe24AuthWindowRef.current.closed) {
        cafe24AuthWindowRef.current.close();
      }
    };
  }, []);

  // 사용자 정보가 갱신될 때 cafe24 인증 여부를 확인한다.
  useEffect(() => {
    const hasCafe24AuthUrl = platformInfo.params && !!(platformInfo.params as any)?.cafe24_auth_url;
    if (hasCafe24AuthUrl) {
      setIsCafe24AuthConfirmModalOpen(true);
    }
  }, [platformInfo]);

  return (
    <>
      {platformInfo.type === 'cafe24' && (
        <>
          <ConfirmModal
            setOpen={isCafe24AuthConfirmModalOpen}
            onClose={() => {
              setIsCafe24AuthConfirmModalOpen(false);
            }}
            onAuth={() => {
              if (platformInfo.params && 'cafe24_auth_url' in platformInfo.params) {
                openCenteredWindow(platformInfo.params.cafe24_auth_url, '_blank', 980, 720);
              } else {
                navigate('/main');
              }
              setIsCafe24AuthConfirmModalOpen(false);
            }}
          />
          <ErrorModal
            setOpen={isCafe24AuthErrorModalOpen}
            onClose={() => {
              setIsCafe24AuthErrorModalOpen(false);
            }}
          />
        </>
      )}
    </>
  );
};

export default PlatformAuth;
